module.exports = __webpack_public_path__ + "static/project-16b-43c5fd5ddc59db719727702960ac1b8e.png";